import type { SVGProps } from 'react';
import useRandomIds from '@/shared/hooks/useRandomIds';

const Network = ({
  secondaryColor,
  ...props
}: SVGProps<SVGSVGElement> & { secondaryColor?: string } = {}): React.JSX.Element => {
  const [id] = useRandomIds('network-icon', 1, []);
  const variableName = `--${id}-secondary-color`;

  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ [variableName]: secondaryColor ?? 'currentColor' }}
      {...props}
    >
      <circle cx="12" cy="5.50082" r="1.25" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="12" cy="12.5008" r="1.25" stroke={`var(${variableName})`} strokeWidth="1.5" />
      <circle
        cx="19"
        cy="12.5008"
        r="1.25"
        transform="rotate(90 19 12.5008)"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <circle
        cx="16"
        cy="16.5008"
        r="0.75"
        transform="rotate(90 16 16.5008)"
        fill={`var(${variableName})`}
      />
      <circle
        cx="16"
        cy="8.25082"
        r="0.75"
        transform="rotate(90 16 8.25082)"
        fill={`var(${variableName})`}
      />
      <circle
        cx="7.75"
        cy="16.5008"
        r="0.75"
        transform="rotate(90 7.75 16.5008)"
        fill={`var(${variableName})`}
      />
      <circle
        cx="7.75"
        cy="8.25082"
        r="0.75"
        transform="rotate(90 7.75 8.25082)"
        fill={`var(${variableName})`}
      />
      <circle cx="12" cy="19.5008" r="1.25" stroke="currentColor" strokeWidth="1.5" />
      <circle
        cx="5"
        cy="12.5008"
        r="1.25"
        transform="rotate(90 5 12.5008)"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default Network;
